import './badge.css';
export default {
  "badge": "pf-v6-c-badge",
  "badgeToggleIcon": "pf-v6-c-badge__toggle-icon",
  "modifiers": {
    "read": "pf-m-read",
    "unread": "pf-m-unread",
    "disabled": "pf-m-disabled"
  }
};